
import { computed, defineComponent, onMounted, ref } from 'vue';
import { useDeviceSize } from 'SharedDir/common/composables/useDeviceSize';
import { usePublicStatistics } from 'PortalDir/modules/Main/components/Statistics/composables/usePublicStatistics';
import DigitCounter from 'SharedComponents/ui/DigitCounter.vue';
import { ATTACHMENT_ENDPOINTS } from 'SharedDir/backend/endpoints/attachments';
import { useAppStore } from 'stores/app';

export default defineComponent({
  name: 'IssueDepList',
  components: { DigitCounter },

  setup() {
    const appStore = useAppStore();
    const issueDepList = computed(() => {
      return appStore.issueDepPublicList;
    });

    const isSsr = computed(() => {
      return appStore.isMainSsrLoad;
    });

    const { getIssuesDepList } = usePublicStatistics();
    const { isMobile } = useDeviceSize();
    const statisticTitle: string = 'Количество мер поддержки';
    const list = ref<any>([]);

    const countIssues = computed(() => {
      if (issueDepList.value.length !== 0) {
        return issueDepList.value
          .map((x) => x?.count)
          .reduce((accumulator, currentValue) => accumulator + currentValue, 0);
      }
      return 0;
    });

    const getImage = (imageId: string): string => {
      return ATTACHMENT_ENDPOINTS.GET(imageId).url;
    };

    onMounted(async () => {
      // list.value = await getIssuesDepList();
      // appStore.setIssueDepPublicList(list.value);
      await appStore.setMainSsrLoad(false);
    });

    return { issueDepList, isMobile, statisticTitle, getImage, countIssues, isSsr };
  },
});
